export default __webpack_public_path__ + "static/service-1-02a594cd2856917d0298e1d1d04d5abc.jpg";